'use strict';
namespace TR {
     angular
        .module('TR')
        .component('crossSellAttractions', {
            bindings: {
                isHotelJourney: '<',
                hotel: '<?'
            },
            controller: 'Attractions',
            controllerAs: 'at',
            templateUrl: 'partials/home/directivetemplate?type=CrossSellAttractions'
        });
}
